import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Minibusonrentinpune() {



  const cardData = {
"keyword": "Mini Bus On Rent in Pune",

"headingDescription":
  "Aaradhya Travels offers comfortable and affordable Mini Bus On Rent in Pune for family trips, corporate travel, weddings, school picnics, outstation tours, and group transportation. Our well-maintained AC mini buses with professional drivers ensure safe, spacious, and smooth travel for all types of group journeys across Pune and Maharashtra.",

"topPlaces": [
 
  {
    "title": "Lavasa City",
    "description": "Lavasa is a planned hill city near Pune featuring lakeside views, colorful architecture, and a peaceful environment for short holidays."
  },
  {
    "title": "Shirdi",
    "description": "Shirdi is a major pilgrimage town near Pune dedicated to Sai Baba, attracting devotees throughout the year for spiritual visits."
  },
   {
    "title": "Lonavala",
    "description": "Lonavala is a popular hill station near Pune known for scenic valleys, waterfalls, and weekend getaways, perfect for group and family trips."
  },
  {
    "title": "Mahabaleshwar",
    "description": "Mahabaleshwar is a famous hill destination near Pune offering cool weather, strawberry farms, viewpoints, and refreshing monsoon scenery."
  },
  {
    "title": "Nashik",
    "description": "Nashik is a historic city near Pune known for vineyards, temples, and the sacred Trimbakeshwar Jyotirlinga shrine."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort near Pune is a historic hill fort offering trekking routes and panoramic views of the Sahyadri mountains."
  },
  {
    "title": "Karla Bhaja Caves",
    "description": "Karla and Bhaja Caves near Pune are ancient Buddhist rock-cut caves known for historical significance and architectural beauty."
  },
  {
    "title": "Pawna Lake",
    "description": "Pawna Lake near Lonavala is a popular camping destination offering lakeside stays, bonfires, and adventure activities."
  },
  {
    "title": "Mumbai",
    "description": "Mumbai is a major metro city near Pune, popular for business trips, tourism, beaches, and weekend travel."
  },
  {
    "title": "Khandala",
    "description": "Khandala is a scenic hill station close to Lonavala, famous for valleys, viewpoints, and monsoon landscapes."
  }
],



services: [
  {
    name: "Mini Bus on Rent",
    description: "Mini bus on rent service provides spacious and comfortable transportation for family trips, corporate outings, school tours, wedding events, airport transfers, and outstation travel. Well-maintained vehicles ensure smooth highway journeys suitable for group travel and sightseeing requirements. Professional chauffeurs provide safe driving and dependable transportation services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient mini bus rental reservations."
  },
  {
    name: "Mini Bus Hire in Pune",
    description: "Mini bus hire in Pune service offers reliable transportation for group travel, business events, family vacations, educational tours, and local sightseeing trips. Comfortable seating and spacious interiors ensure pleasant journeys suitable for long-distance and local travel requirements. Professional drivers ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow easy mini bus hire reservations."
  },
  {
    name: "Minibus Hire with Driver for Outstation",
    description: "Minibus hire with driver for outstation service provides dependable transportation for long-distance travel including Goa, Mahabaleshwar, Nashik, Shirdi, Kolhapur, and other tourist destinations. Spacious vehicles ensure comfortable highway travel suitable for families, tourists, and corporate groups. Professional chauffeurs ensure safe driving and reliable transportation services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient outstation minibus reservations."
  },
  {
    name: "Mini Bus Rentals for Corporate Trip",
    description: "Mini bus rentals for corporate trip service offers professional transportation for office outings, employee travel, conferences, business meetings, and team events. Comfortable seating and spacious interiors ensure smooth travel experiences suitable for corporate passengers and executive groups. Professional chauffeurs provide punctual pickup and safe transportation services throughout the route. Pickup services are available from IT parks, offices, hotels, airports, and commercial areas across Pune. Flexible booking options allow convenient corporate mini bus reservations."
  },
  {
    name: "Small Bus Rental Service in Pune",
    description: "Small bus rental service in Pune provides economical and comfortable transportation for family functions, educational trips, airport transfers, local sightseeing, and outstation tours. Spacious vehicles ensure smooth highway travel suitable for group journeys and event transportation. Professional chauffeurs ensure safe driving and timely pickup services throughout the trip. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient small bus rental reservations."
  },
  {
    name: "Minibus Rental Near Me in Pune",
    description: "Minibus rental near me in Pune service offers convenient and dependable transportation for local and outstation group travel requirements. Comfortable vehicles ensure smooth travel suitable for family outings, business trips, wedding travel, and sightseeing tours. Professional drivers ensure safe transportation and punctual pickup services throughout the journey. Pickup services are available across all major Pune locations including homes, offices, hotels, railway stations, and airports. Flexible booking options allow convenient nearby minibus reservations."
  },
  {
    name: "Mini Bus Rent Per KM",
    description: "Mini bus rent per km service provides transparent and affordable transportation solutions for local travel, outstation trips, family tours, and corporate group journeys. Spacious vehicles ensure comfortable seating and smooth highway travel suitable for all passenger groups. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient mini bus rental bookings."
  },
  {
    name: "Mini Coach Hire in Pune",
    description: "Mini coach hire in Pune service offers premium transportation for educational tours, family vacations, business travel, wedding events, and group sightseeing tours. Comfortable seating and spacious cabins ensure smooth journeys suitable for local and long-distance travel. Professional chauffeurs ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient mini coach hire reservations."
  },
  {
    name: "Mini Bus for Rent Near Me in Pune",
    description: "Mini bus for rent near me in Pune service provides reliable transportation for local group travel, airport transfers, family outings, and corporate events. Spacious vehicles ensure comfortable journeys suitable for all passenger groups and travel requirements. Professional drivers ensure safe driving and dependable transportation services throughout the route. Pickup services are available across residential areas, offices, hotels, railway stations, and airport terminals throughout Pune. Flexible booking options allow convenient nearby mini bus reservations."
  },
  {
    name: "12 Seater Mini Bus on Rent Pune",
    description: "12 seater mini bus on rent Pune service offers comfortable transportation for small groups, family vacations, office outings, and airport transfers. Spacious seating and luggage capacity ensure smooth travel experiences suitable for local and outstation journeys. Professional chauffeurs provide safe driving and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient 12 seater mini bus reservations."
  },
  {
    name: "Mini Bus on Rent Near Me for Outstation",
    description: "Mini bus on rent near me for outstation service provides dependable transportation for long-distance travel, weekend getaways, pilgrimage tours, and family vacations. Comfortable vehicles ensure smooth highway travel suitable for tourists, families, and corporate passengers. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient outstation mini bus reservations."
  },
  {
    name: "Mini Bus for Lonavala Picnic from Pune",
    description: "Mini bus for Lonavala picnic from Pune service offers comfortable transportation for one-day trips, school picnics, family outings, and corporate group travel to Lonavala. Spacious vehicles ensure smooth expressway and hill station journeys suitable for tourists and weekend travelers. Professional drivers provide safe driving and dependable transportation services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient Lonavala mini bus reservations."
  },
  {
    name: "Mini Bus Hire for Event in Pune",
    description: "Mini bus hire for event in Pune service provides reliable transportation for weddings, corporate events, birthday parties, conferences, exhibitions, and family functions. Comfortable seating and spacious interiors ensure smooth travel suitable for guest transportation and event management. Professional chauffeurs ensure punctual pickup and safe transportation services throughout the schedule. Pickup services are available from homes, hotels, offices, banquet halls, railway stations, and airports across Pune. Flexible booking options allow convenient event mini bus reservations."
  },
  {
    name: "Pune to Goa Mini Bus",
    description: "Pune to Goa mini bus service offers premium transportation for beach vacations, family tours, corporate outings, bachelor trips, and tourist travel from Pune. Spacious vehicles ensure comfortable overnight and long-distance journeys with luggage space suitable for group travel. Professional drivers ensure safe highway driving and dependable transportation services throughout the Goa route. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient Goa mini bus reservations."
  },
  {
    name: "Mini Bus Hire in Pimpri Chinchwad",
    description: "Mini bus hire in Pimpri Chinchwad service provides comfortable transportation for local travel, airport transfers, family functions, educational tours, and outstation trips. Spacious vehicles ensure smooth journeys suitable for families, tourists, and business travelers. Professional chauffeurs ensure safe driving and timely pickup services across all routes. Pickup services are available from residential societies, offices, hotels, and commercial areas across Pimpri Chinchwad. Flexible booking options allow convenient mini bus reservations."
  },
  {
    name: "Mini Bus Hire in Kharadi Pune",
    description: "Mini bus hire in Kharadi Pune service offers dependable transportation for corporate teams, airport transfers, office events, and group outings from Kharadi Pune. Comfortable vehicles ensure smooth travel suitable for IT professionals, tourists, and family passengers. Professional chauffeurs ensure safe driving and reliable transportation services throughout the journey. Pickup services are available from IT parks, residential societies, offices, hotels, and commercial areas across Kharadi Pune. Flexible booking options allow convenient mini bus hire reservations."
  },
  {
    name: "Minibus Hire for Wedding Party in Pune",
    description: "Minibus hire for wedding party in Pune service provides luxurious and spacious transportation for wedding guests, family members, bridal parties, and event functions. Comfortable seating and stylish interiors ensure smooth travel suitable for marriage ceremonies and celebrations. Professional drivers ensure punctual pickup and dependable transportation services throughout the event schedule. Pickup services are available from homes, hotels, banquet halls, railway stations, and airport terminals across Pune. Flexible booking options allow convenient wedding minibus reservations."
  },
  {
    name: "Mini Bus on Rent in Hinjewadi",
    description: "Mini bus on rent in Hinjewadi service offers reliable transportation for IT companies, employee travel, airport transfers, corporate outings, and family tours. Spacious vehicles ensure comfortable journeys suitable for office teams and group travel requirements. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from IT parks, offices, residential societies, hotels, and commercial locations across Hinjewadi Pune. Flexible booking options allow convenient mini bus reservations."
  },
  {
    name: "Mini Bus on Rent in Baner",
    description: "Mini bus on rent in Baner service provides dependable transportation for local sightseeing, family outings, corporate events, airport transfers, and outstation trips. Comfortable vehicles ensure smooth travel suitable for tourists, business travelers, and family groups. Professional drivers provide safe transportation and reliable pickup services across all routes. Pickup services are available from homes, offices, hotels, and commercial locations across Baner Pune. Flexible booking options allow convenient mini bus reservations."
  },
  {
    name: "Mini Bus on Rent in Pune Near Me",
    description: "Mini bus on rent in Pune near me service offers convenient and affordable transportation for local group travel, event transportation, family trips, and outstation journeys. Spacious seating and comfortable interiors ensure pleasant travel experiences for all passengers. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available across all major Pune locations including homes, offices, hotels, railway stations, and airports. Flexible booking options allow convenient nearby mini bus reservations."
  },
  {
    name: "Luxury Mini Bus on Rent in Pune Near",
    description: "Luxury mini bus on rent in Pune near service provides premium transportation with comfortable seating, air conditioning, spacious cabins, and stylish interiors for luxury travel experiences. Vehicles are suitable for weddings, corporate events, VIP transportation, family vacations, and group sightseeing tours. Professional chauffeurs ensure smooth highway travel and reliable transportation services throughout the journey. Pickup services are available from homes, hotels, offices, banquet halls, railway stations, and airport terminals across Pune. Flexible booking options allow convenient luxury mini bus reservations."
  }
],

tableData: [
  ["Mini Bus on Rent", "Mini Bus Hire in Pune"],
  ["Minibus Hire with Driver for Outstation", "Mini Bus Rentals for Corporate Trip"],
  ["Small Bus Rental Service in Pune", "Minibus Rental Near Me in Pune"],
  ["Mini Bus Rent Per KM", "Mini Coach Hire in Pune"],
  ["Mini Bus for Rent Near Me in Pune", "12 Seater Mini Bus on Rent Pune"],
  ["Mini Bus on Rent Near Me for Outstation", "Mini Bus for Lonavala Picnic from Pune"],
  ["Mini Bus Hire for Event in Pune", "Pune to Goa Mini Bus"],
  ["Mini Bus Hire in Pimpri Chinchwad", "Mini Bus Hire in Kharadi Pune"],
  ["Minibus Hire for Wedding Party in Pune", "Mini Bus on Rent in Hinjewadi"],
  ["Mini Bus on Rent in Baner", "Mini Bus on Rent in Pune Near Me"],
  ["Luxury Mini Bus on Rent in Pune Near", "Mini Bus on Rent"]
],


 whychoose: [
      {
        WhyChooseheading: "Reliable Mini Bus On Rent in Pune",
        WhyChoosedescription: "Aaradhya Travels provides reliable mini bus rental service in Pune with comfortable vehicles, professional drivers, and smooth travel arrangements for family trips, corporate tours, weddings, and group outings."
      },
      {
        WhyChooseheading: "Affordable Mini Bus Rental Packages",
        WhyChoosedescription: "Aaradhya Travels offers affordable mini bus on rent in Pune with transparent pricing, flexible booking options, and complete travel support without hidden charges."
      },
      {
        WhyChooseheading: "24/7 Mini Bus Booking Service",
        WhyChoosedescription: "Our mini bus rental service in Pune operates 24 hours for airport transfers, employee transportation, picnic tours, school trips, wedding events, and outstation group travel."
      },
      {
        WhyChooseheading: "Comfortable & Fully AC Mini Buses",
        WhyChoosedescription: "All mini buses provided by Aaradhya Travels are spacious, air-conditioned, clean, and regularly maintained to provide safe and comfortable travel experiences."
      },
      {
        WhyChooseheading: "One Day & Multi-Day Group Travel",
        WhyChoosedescription: "Aaradhya Travels offers flexible travel plans including one-day tours, weekend trips, corporate outings, pilgrimage journeys, and customized multi-day travel packages."
      },
      {
        WhyChooseheading: "Wide Range of Seating Capacity Options",
        WhyChoosedescription: "Customers can choose mini buses with different seating capacities suitable for family functions, school groups, office teams, tourists, and event transportation requirements."
      },
      {
        WhyChooseheading: "Pickup Available Across Pune City",
        WhyChoosedescription: "Aaradhya Travels provides convenient pickup from Pune Airport, railway stations, hotels, homes, and all major Pune areas including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Safe Group Travel",
        WhyChoosedescription: "Our professional drivers are experienced in handling city and outstation routes, ensuring safe driving, smooth journeys, and timely travel for every group trip."
      }
    ]
  };

  const faqData = [
    { question: "What is mini bus on rent in Pune?", answer: "Mini bus on rent in Pune provides comfortable group transportation for corporate travel, family trips, school tours, weddings, and outstation journeys." },
    { question: "Is mini bus booking available 24 hours in Pune?", answer: "Yes, Aaradhya Travels provides 24/7 mini bus rental service in Pune." },
    { question: "Which seating capacity mini buses are available?", answer: "Aaradhya Travels offers mini buses with multiple seating capacities suitable for small and large group travel." },
    { question: "Can I book mini bus for outstation travel?", answer: "Yes, customers can book mini buses for outstation trips, family vacations, corporate tours, and holiday travel." },
    { question: "Do you provide mini buses for corporate events?", answer: "Yes, Aaradhya Travels provides mini bus rental services for corporate meetings, office outings, conferences, and employee transportation." },
    { question: "Are all mini buses air-conditioned?", answer: "Yes, all mini buses are fully air-conditioned and maintained for comfortable group travel." },
    { question: "Can I book mini bus online in Pune?", answer: "Yes, customers can easily book mini bus rental service online or through phone booking." },
    { question: "Do you provide mini buses for family and wedding travel?", answer: "Yes, Aaradhya Travels provides spacious mini buses suitable for weddings, family functions, and group events." },
    { question: "Are mini bus rental charges transparent?", answer: "Yes, Aaradhya Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for mini bus rental service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, and wedding seasons." }
  ];

const testimonials = [
  {
    id: 1,
    name: "Mr. Tushar Kulkarni",
    feedback:
      "Traveling in Pune with a group became much more convenient thanks to the mini bus arranged by Aaradhya Travels. The journey felt smooth, and everyone could sit together comfortably without any travel stress.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Rutuja Jadhav",
    feedback:
      "Aaradhya Travels provided a mini bus on rent in Pune for our family outing, and the experience was very well managed. The vehicle was clean, spacious, and made group travel easy and comfortable.",
    rating: 5
  }
];








  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Mahabaleshwar Tempo Traveller", link: "Pune-to-Mahabaleshwar-Tempo-Traveller" },
    { place: "/images/keyword/3.jpg", text: "Pune to Outstation Tempo Traveller", link: "Pune-to-Outstation-Tempo-Traveller" },
    { place: "/images/keyword/4.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Mini Bus on Rent Pune", link: "Outstation-Mini-Bus-on-Rent-Pune" },
    { place: "/images/keyword/6.jpg", text: "14 Seater Tempo Traveller on Rent in Pune", link: "14-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "17 Seater Bus on Rent in Pune", link: "17-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Tempo Traveller", link: "Pune-to-Shirdi-Tempo-Traveller" },
    { place: "/images/keyword/9.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/10.jpg", text: "25 Seater Tempo Traveller on Rent in Pune", link: "25-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/11.jpg", text: "Tempo Traveller on Rent in Pimpri Chinchwad", link: "Tempo-Traveller-on-Rent-in-Pimpri-Chinchwad" },
    { place: "/images/keyword/12.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
    { place: "/images/keyword/13.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/14.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/15.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/16.jpg", text: "Non AC Bus Rental Service in Pune", link: "Non-AC-Bus-Rental-Service-in-Pune" },
    { place: "/images/keyword/17.jpg", text: "Luxury Bus Rental in Pune", link: "Luxury-Bus-Rental-in-Pune" },
    { place: "/images/keyword/18.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "Luxury-Force-Urbania-On-Rent-in-Pune" },
    { place: "/images/keyword/19.jpg", text: "Force Urbania Luxury Mini Bus On Rent", link: "Force-Urbania-Luxury-Mini-Bus-On-Rent" },
    { place: "/images/keyword/20.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune-2" },
    { place: "/images/keyword/21.jpg", text: "14 17 20 25 Seater Bus on Rent in Pune", link: "14-17-20-25-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/22.jpg", text: "Travel Agents in Pune for Mini Bus Hire", link: "Travel-Agents-in-Pune-for-Mini-Bus-Hire" },
    { place: "/images/keyword/23.jpg", text: "Tempo Traveller Hire in Pune", link: "Tempo-Traveller-Hire-in-Pune" },
  ];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mini Bus On Rent in Pune",
  "image": "https://www.aaradhyatravels99.com/assets/images/mini-bus-on-rent-pune.jpg",
  "description": "Book Mini Bus on rent in Pune with Aaradhya Travels for corporate trips, family outings, weddings, events, airport transfers, picnics, and outstation travel. Affordable 12 seater and luxury mini bus rental service available with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Aaradhya Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "3264"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "https://www.aaradhyatravels99.com/mini-bus-on-rent-in-pune"
  }
};



  return (
    <div>

<Helmet>
  <title>
    Mini Bus On Rent in Pune | 12 Seater Mini Bus Hire | +91 9529697070
  </title>

  <meta
    name="description"
    content="Hire Mini Bus on rent in Pune with Aaradhya Travels. Affordable 12 seater mini bus rental service for corporate trips, events, weddings, airport transfers, Lonavala picnics, local sightseeing, and outstation tours with driver."
  />

  <meta
    name="keywords"
    content="Mini bus on rent, Mini bus hire in Pune, Minibus hire with driver for outstation, Mini bus rentals for CorporateTrip, Small bus rental service in Pune, Minibus rental near me in Pune, Mini Bus Rent Per Km, Mini coach hire in Pune, Mini bus for rent near me in Pune, 12 seater mini bus on rent Pune, Mini bus on rent near me for Outstation, Mini bus for lonavala Picnic from Pune, Mini bus Hire for event in Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1
                  className="text-anime-style-3 text-center text-white"
                  data-cursor="-opaque"
                >
                  {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/4.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#FFB100', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Aaradhya Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaradhya Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaradhya Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529697070" className="pc-call">+91 9529697070</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529697070"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529697070" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@aaradhyatravels99.com" className="pc-email">
                      booking@aaradhyatravels99.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aaradhya Travels</strong><br />
                      Near RMD College, Opp. Chaudhary Parking, Warje, Pune - 411058
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Minibusonrentinpune;